import React from "react";
import styled from "styled-components";

import TeamsCard from "./TeamsCard";
import { RiTeamFill } from "react-icons/ri";
import { teamsArray } from "../data/TeamsData";

const TeamsList = () => {
  return (
    <>
      <div class="grid grid-cols-1 lg:grid-cols-4 gap-1 ">
        {teamsArray.map((projectItem) => (
          <TeamsCard
            title={projectItem.name}
            bgColor={projectItem.color}
            bgImg={projectItem.img}
            borderColor={projectItem.borderColor}
            teamPath={projectItem.path}
            supportTeam={projectItem.supportTeam}
            mailUrl={projectItem.mailurl}
          />
        ))}
      </div>

      {/* <div class="grid md:grid-cols-3 grid-cols-1 gap-4">
       

        <Link to="/projects">
          <div className="transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-110 rounded-sm my-6 mx-1 shadow-md	shadow-slate-400">
            <div className="bg-teal-500">
              <img src={ProjectOne} alt="laptop" />

              <div className="text-white text-center text-2xl tracking-wide py-3">
                Operations <SupportIcon />
              </div>
            </div>
          </div>
        </Link>
        <Link to="/projects">
          <div className="transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-110 rounded-sm my-6 mx-1 shadow-md	shadow-slate-400">
            <div className="bg-indigo-500">
              <img src={ProjectOne} alt="laptop" />
              <div className="text-white text-center text-2xl tracking-wide py-3">
                Marketing & Promotions <SupportIcon />
              </div>
            </div>
          </div>
        </Link>
        <Link to="/projects">
          <div className="transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-110 rounded-sm my-6 mx-1 shadow-md	shadow-slate-400">
            <div className="bg-pink-500">
              <img src={ProjectOne} alt="laptop" />

              <div className="text-white text-center text-2xl tracking-wide py-3">
                Editorial & design
              </div>
            </div>
          </div>
        </Link>
        <Link to="/projects">
          <div className="transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-110 rounded-sm my-6 mx-1 shadow-md	shadow-slate-400">
            <div className="bg-neutral-500">
              <img src={ProjectOne} alt="laptop" />
              <div className="text-white text-center text-2xl tracking-wide py-3">
                Digital Design
              </div>
            </div>
          </div>
        </Link>
        <Link to="/projects">
          <div className="transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-110 rounded-sm my-6 mx-1 shadow-md	shadow-slate-400">
            <div className="bg-amber-500">
              <img src={ProjectOne} alt="laptop" />
              <div className="text-white text-center text-2xl tracking-wide py-3">
                Web & App
              </div>
            </div>
          </div>
        </Link>
        <Link to="/projects">
          <div className="transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-110 rounded-sm my-6 mx-1 shadow-md	shadow-slate-400">
            <div className="bg-indigo-500">
              <img src={ProjectOne} alt="laptop" />
              <div className="text-white text-center text-2xl tracking-wide py-3">
                Event Planning
              </div>
            </div>
          </div>
        </Link>
        <Link to="/projects">
          <div className="transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-110 rounded-sm my-6 mx-1 shadow-md	shadow-slate-400">
            <div className="bg-indigo-500">
              <img src={ProjectOne} alt="laptop" />

              <div className="text-white text-center text-2xl tracking-wide py-3">
                Finance <SupportIcon />
              </div>
            </div>
          </div>
        </Link>
      </div> */}
    </>
  );
};
const SupportIcon = styled(RiTeamFill)`
  display: inline;
  color: orange;
  padding-bottom: 2px;
  font-size: 1.5rem;
`;
export default TeamsList;
